import { createQueryHook } from '@fourthwall/utils/dist/queries';
import { OffersApiClient } from '@fourthwall/services/dist/OffersApiClient';
import { decodeHtmlEntities } from '@fourthwall/utils/dist/sanitize';
export const useOffersByIdsQuery = createQueryHook(OffersApiClient.getOffersByIds, {
    queryKey: ['offersByIds'],
    select: (data) => Object.entries(data).reduce((acc, [id, offer]) => ({ ...acc, [id]: { ...offer, name: decodeHtmlEntities(offer.name) } }), {}),
});
